export const DEFAULT_BENEFIT_CARDS = [
  {
    title: "A packed schedule",
    description:
      "Get ready for three days of disruptive ideas and ground-breaking insights - we’re really proud of the speakers, panels and activities we’ve put together.",
    icon: "/canvas/hazel/icons/icon-1.05027c95.svg",
  },
  {
    title: "Living it your way",
    description:
      "With multiple thematic tracks you can pick and choose what sessions you want to join and create your own schedule.",
    icon: "/canvas/hazel/icons/icon-2.f10217f0.svg",
  },
  {
    title: "Not just watching",
    description:
      "Live Q&As, in-session chat, polls, games, whiteboard and brainstorming sessions... thought this was going to be only about watching people talk? Think again.",
    icon: "/canvas/hazel/icons/icon-3.bc346cdd.svg",
  },
  {
    title: "Food for thought",
    description:
      "We carefully selected our speakers with the goal of bringing really though-provoking, disruptive ideas to the table.",
    icon: "/canvas/hazel/icons/icon-4.8b565662.svg",
  },
  {
    title: "Meaningful connections",
    description:
      "Be ready to meet other brilliant minds, exchange ideas, network and lay the foundations for new, fruitful partnerships thanks to our Networking area.",
    icon: "/canvas/hazel/icons/icon-5.4b0d6c90.svg",
  },
  {
    title: "Extra content and recordings",
    description:
      "You’ll have access to all recordings after the event is over, so you can go back an rewatch the sessions you didn’t catch live. We’ll also share slides and more extras.",
    icon: "/canvas/hazel/icons/icon-6.d088c1ed.svg",
  },
];
